import React from 'react';
import Navbar from '../../home/navbar';

import Footer from '../../home/footer';
import { Community_Nav } from '../community_nav';
import '../css_files/community_homepage.css';
import WelcomeMessage from './welcome_message.jsx'
import ContentsArea from './contents_area'


export const CommunityHome = () => {

    return (
        <div>
            <div>
                <Community_Nav />
                <div className='overall-bg'>
                    <div className='contents-area'>
                        <ContentsArea />
                    </div>
                    <div className='bg-dark text-white'><Footer /></div>

                </div>

            </div>
        </div>
    )
}

//Welcome to the afbr community section
//Adverts
//Posts
//Featured articles
//Newly registered